import React, { forwardRef } from 'react'

type PinPadProps = {
  value: string
  onChange: (value: string) => void
} & React.InputHTMLAttributes<HTMLInputElement>

type Ref = HTMLButtonElement
const PinPad = ({ value, onChange, ...rest }, ref) => {
  const handleChange = (item: string | number) => {
    let newValue = '';

    if (item === '<<') {
      newValue = value.slice(0, -1);
    } else {
      const digit = String(item).replace(/\D/g, '');
      newValue = (value + digit).slice(0, 6);
    }

    onChange(newValue);
  };


  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const raw = e.target.value;
    const onlyDigits = raw.replace(/\D/g, '').slice(0, 6);
    onChange(onlyDigits);
  }

  return (
    <div className="">
      <div className="flex gap-2 justify-center py-8">
        <div>
          <input
            type="tel"
            pattern="[0-9]*"
            autoComplete="one-time-code"
            className="border-2 rounded w-full h-12 px-2"
            value={value}
            onChange={handleInputChange}
            {...rest}
          />
        </div>
      </div>
      <div className="grid grid-cols-3 grid-rows-4 gap-6 place-items-center">
        {[1, 2, 3, 4, 5, 6, 7, 8, 9, 0, '<<'].map(item => {
          const isBackspace = item === '<<';
          const ariaLabel = isBackspace ? 'Cancella ultima cifra' : `Digita ${item}`;

          return (
            <button
              type="button"
              ref={ref}
              key={item}
              onClick={() => handleChange(item)}
              aria-label={ariaLabel}
              className={`${item === 0 && 'col-start-2'
                } w-14 h-14 border border-black rounded-full text-center font-bold text-xl text-black bg-gray-200 bg-opacity-40 hover:bg-opacity-100 hover:bg-blue-400 hover:border-blue-800 hover:text-blue-900 `}
            >
              {item}
            </button>
          );
        })}

      </div>
    </div>
  )
}

export default forwardRef<Ref, PinPadProps>(PinPad)
